import * as requestActionCreators from '../../../redux/modules/request';

const mapStateToProps = state => ({
  requestStore: state.request,
  language: state.auth.language,
});

const mapDispatchToProps = {
  ...requestActionCreators
};
export default [mapStateToProps, mapDispatchToProps];



// WEBPACK FOOTER //
// ./src/containers/user/dashboard/index.js